import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { setTimeZone } from "../../commands/mdmCommands";

export const TIME_ZONE_OPTIONS = [
  "Europe/Berlin",
  "Europe/Vienna",
  "Europe/Zurich",
  "Europe/Luxembourg",
  "Europe/Brussels",
  "UTC",
];

function TimeZoneModal({ visible, device, hideModal, onIssued }) {
  const [show, setShow] = useState(false);
  const current = device?.QueryResponses?.TimeZone || "Europe/Berlin";
  const [timeZone, setZone] = useState(current);

  const handleClose = () => {
    setShow(false);
    hideModal();
  };

  useEffect(() => {
    setShow(visible);
    setZone(device?.QueryResponses?.TimeZone || "Europe/Berlin");
  }, [visible, device]);

  function send() {
    const zone = String(timeZone || "").trim();
    if (!zone) return;
    setTimeZone(device.UDID, zone).then(() => {
      onIssued?.();
      handleClose();
    });
  }

  const known = TIME_ZONE_OPTIONS.includes(timeZone);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Zeitzone</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Aktuell: <strong>{current || "—"}</strong>
        </p>
        <label htmlFor="timeZoneSelect" className="form-label">
          IANA-Zeitzone
        </label>
        <select
          id="timeZoneSelect"
          className="form-select mb-3"
          value={known ? timeZone : "__custom"}
          onChange={(e) => {
            if (e.target.value === "__custom") setZone("");
            else setZone(e.target.value);
          }}
        >
          {TIME_ZONE_OPTIONS.map((zone) => (
            <option key={zone} value={zone}>
              {zone}
            </option>
          ))}
          <option value="__custom">Andere…</option>
        </select>
        {!known ? (
          <input
            type="text"
            className="form-control mb-3"
            value={timeZone}
            onChange={(e) => setZone(e.target.value)}
            placeholder="Europe/Berlin"
          />
        ) : null}
        <div className="form-text">
          Nur betreute Geräte ab iOS/iPadOS/tvOS 14. Schlägt fehl, wenn
          automatische Datum/Uhrzeit erzwungen ist.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
        <Button variant="success" disabled={!String(timeZone || "").trim()} onClick={send}>
          Zeitzone setzen
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TimeZoneModal;
